/**
 * ExhibitsDisplaysV3 — scaffold shell
 * Flag: exhibitsDisplaysV3
 * API: api/v3/exhibitsdisplays (stub returning { message: 'ExhibitsDisplaysV3 stub' })
 * NOTE: This is the successor to the Workflow domain (Workflow/ frontend + v1 WorkflowController).
 *       Full rewrite: 11 .js files → TypeScript, class components → hooks, v1 API → v3 API.
 * TODO: Replace stub with real Exhibits & Displays RTK Query endpoints and AG Grid
 */
import React from 'react';
import { useGetExhibitsDisplaysV3Query } from '../../api/exhibitsDisplaysV3Api';

export default function ExhibitsDisplaysV3() {
    const { data, isLoading, isError } = useGetExhibitsDisplaysV3Query();

    if (isLoading) return <p>Loading…</p>;
    if (isError)   return <p>Error loading Exhibits &amp; Displays.</p>;

    return (
        <main aria-label="Exhibits &amp; Displays v3 (scaffold)">
            <p>ExhibitsDisplaysV3 scaffold — {JSON.stringify(data)}</p>
        </main>
    );
}
